'use client';

import { type ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { BackButton } from '@components/mobile/navigation/back-button';
import { SidebarTrigger, useSidebar } from '@components/ui/sidebar';
import { usePageChrome } from './page-chrome-context';

function SidebarToggle() {
  const t = useTranslations('app-chrome');
  const { open } = useSidebar();
  return (
    <SidebarTrigger
      label={t('toggle-sidebar')}
      tooltip={`${open ? t('hide-sidebar') : t('show-sidebar')} · ⌘B`}
    />
  );
}

export function DesktopTopBar({
  children
}: {
  organization_id?: string;
  children: ReactNode;
}) {
  const { chrome } = usePageChrome();

  if (chrome?.hideDesktopHeaderActions) {
    return (
      <header className="hidden h-[var(--app-topbar-height)] shrink-0 items-center gap-2 border-b pl-5 pr-7 desktop-chrome:flex">
        <SidebarToggle />
        {chrome.backHref ? (
          <BackButton href={chrome.backHref} label={chrome.backLabel} />
        ) : null}
        <div className="ml-auto flex items-center gap-1.5">
          {chrome.trailingAction}
        </div>
      </header>
    );
  }

  return (
    <header className="hidden h-[var(--app-topbar-height)] shrink-0 items-center justify-between gap-4 border-b pl-5 pr-7 desktop-chrome:flex">
      <SidebarToggle />
      <div className="flex items-center gap-1">{children}</div>
    </header>
  );
}
